const gsiScript = 'https://accounts.google.com/gsi/client'
const id = 'gsi-client-script'
export const loadGoogleClient = () => {
  return new Promise((resolve, reject) => {
    try {
      if (document.getElementById(id)) {
        resolve(true)
        return
      }

      const scriptEle = document.createElement('script')
      scriptEle.type = 'text/javascript'
      scriptEle.async = true
      scriptEle.src = gsiScript
      scriptEle.id = id

      scriptEle.addEventListener('load', (ev) => {
        resolve(true)
      })

      scriptEle.addEventListener('error', (ev) => {
        reject(Error(`Failed to load the script ${gsiScript}`))
      })

      document.body.appendChild(scriptEle)
    } catch (error) {
      reject(error)
    }
  })
}
